import React from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 70px auto 110px;
  transition: all .8s;

  ${media.mobile`
    margin: 48px auto 66px;
  `}
`;

const ColumnWrapper = Flex.extend`
  width: 100%;
  text-align: center;
  justify-content: space-around;
  transition: all .8s;

  ${media.w800`
    flex-direction: column;
  `}
`;

const Circle = Flex.extend`
  margin: 0 auto;
  width: 312px;
  height: 312px;
  border: solid 1px #d2d2d2;
  border-radius: 50%;
  background-image: url(${props => props.src});
  background-size: contain;
  background-size: 76%;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .8s;

  ${media.tablet`
    width: 270px;
    height: 270px;
  `}
  ${media.w800`
    margin: 0 auto 33px;
  `}
  ${media.mobile`
    width: 296px;
    height: 296px;
  `}
`;

const Title = styled.div`
  width: 90%;
  padding-bottom: 11px;
  border-bottom: 1px solid #dddddd;
  margin: 61px auto 27px;
  font-family: NotoSansCJKkr, sans-serif;
  font-size: 18px;
	font-weight: bold;
	letter-spacing: 0.6px;
  color: #343434;
  text-align: center;

  ${media.mobile`
    margin-top: 33px;
    font-size: 16px;
    text-align: left;
  `}
`;

const Desc = styled.div`
  width: 100%;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  line-height: 1.78;
  text-align: center;
  color: #555555;
  margin: 0 auto 110px;
  word-break: keep-all;

  &.mobile {
    display: none;
  }

  ${media.tablet`
    font-size: 15px;
    line-height: 1.87;
    margin-bottom: 74px;
  `}
  ${media.mobile`
    width: 90%;
    text-align: left;
    margin-bottom: 63px;

    &.mobile {
      display: block;
    }
    &.desk {
      display: none;
    }
  `}
`;

const BodySuit = () => (
    <Wrapper>
      <ColumnWrapper>
        <Circle src="/images/about/sie-short.jpg"/>
        <Circle src="/images/about/sie-long.jpg"/>
        <Circle src="/images/about/sie-quilting.jpg"/>
      </ColumnWrapper>
        <Title>슬립시 숏 / 슬립시 롱 / 슬립시 퀼팅</Title>
        <Desc className="desk">
          총 세가지 종류의 슬립시는 아기들에게 따뜻하게 편안한 잠자리를 만들어주는 파자마(슬리핑백)입니다.<br/>
          슬립시라이트는 사계절용 파자마, 슬립시 퀼티드는 겨울철에 입기 좋은 두께감의 누빔파자마 입니다.<br/>
          코쿤모양으로 디자인 된 슬립네스트는 아이들에게 편안하고 안정감을 주어 밤새 따뜻하게 잠들 수 있도록 도와주는 제품입니다.<br/>
          또한 잠자리에서 기저귀 교체가 쉽도록 다리 쪽이 지퍼로 마무리 되어있습니다.
        </Desc>
        <Desc className="mobile">
          총 세가지 종류의 슬립시는 아기들에게 따뜻하게 편안한 잠자리를 만들어주는 파자마(슬리핑백)입니다.
          슬립시라이트는 사계절용 파자마, 슬립시 퀼티드는 겨울철에 입기 좋은 두께감의 누빔파자마 입니다.<br/>
          코쿤모양으로 디자인 된 슬립네스트는 아이들에게 편안하고 안정감을 주어 밤새 따뜻하게 잠들 수 있도록 도와주는 제품입니다.<br/>
          또한 잠자리에서 기저귀 교체가 쉽도록 다리 쪽이 지퍼로 마무리 되어있습니다.
        </Desc>

      <ColumnWrapper>
        <Circle src="/images/about/kicker.jpg"/>
      </ColumnWrapper>
        <Title>슬립키커</Title>
        <Desc className="desk">
          슬립키커는 밤에 이불을 발로 차내는 아이들을 위한 제품입니다.<br/>
          막 어린이 침대를 졸업했지만 아직 일어나면(이불을 차내서) 추운, 걷기 시작한 아니나 걷는 아이들에게 최적화된 제품입니다.<br/>
          부드럽고 편안한 하이퀄리티 폴리에스테르 후리스로 만들어져 추운 날씨에도 아이들이 편하게 활동할 수 있는 제품입니다.
        </Desc>
        <Desc className="mobile">
          슬립키커는 밤에 이불을 발로 차내는 아이들을 위한 제품입니다.<br/>
          막 어린이 침대를 졸업했지만 아직 일어나면(이불을 차내서) 추운, 걷기 시작한 아니나 걷는 아이들에게 최적화된 제품입니다.<br/>
          부드럽고 편안한 하이퀄리티 폴리에스테르 후리스로 만들어져 추운 날씨에도 아이들이 편하게 활동할 수 있는 제품입니다.
        </Desc>
    </Wrapper>
);

export default BodySuit;



// WEBPACK FOOTER //
// ./src/components/About/BodySuit.js